import Vue from 'vue';
import { gsap } from 'gsap';
import { ScrollTrigger } from '../gsap-bonus/ScrollTrigger';

Vue.component('project-overview-component', {
    data() {
        return {
            activeFilter: null,
            revealsAdded: false,
        };
    },

    props: {
        initialProjects: {
            type: Array,
            default: [],
        },
    },

    computed: {
        projectTypes() {
            const types = [];

            this.initialProjects.forEach((project) => {
                if (types.indexOf(project.category) === -1) {
                    types.push(project.category);
                }
            });

            return types;
        },

        filteredProjects() {
            if (this.activeFilter === null) {
                return this.initialProjects;
            }

            return this.initialProjects.filter((project) => project.category === this.activeFilter);
        },
    },

    mounted() {
        this.initReveals();
    },

    methods: {
        handleFilterClick(filter) {
            if (filter) {
                this.activeFilter = filter;

                ScrollTrigger.killAll();
                this.revealsAdded = false;
            } else {
                ScrollTrigger.killAll();
                this.revealsAdded = false;

                gsap.to('.project-card', {
                    duration: 1,
                    autoAlpha: 0,
                    ease: 'power4.out',
                    onComplete: () => {
                        this.activeFilter = filter;

                        window.scrollTo(0, 0);

                        Vue.nextTick(() => {
                            if (!this.revealsAdded) {
                                this.revealsAdded = true;
                                this.initReveals();
                                EventBus.$emit('refresh-scroll-indicator');
                            }
                        });
                    },
                });

                EventBus.$emit('toggle-filter');
            }
        },

        initReveals() {
            gsap.set(['.project-card', '.project-card__overlay',
                '.project-card__image', '.project-card__button', '.project-card__content'], { clearProps: 'all' });

            ScrollTrigger.batch('.project-card', {
                start: 'top 100%',
                onEnter: (batch) => {
                    batch.forEach((item, index) => {
                        const overlay = item.querySelector('.project-card__overlay');
                        const image = item.querySelector('.project-card__image');
                        const button = item.querySelector('.project-card__button');
                        const content = item.querySelector('.project-card__content');

                        const revealTl = gsap.timeline({
                            delay: index * 0.1,
                            onComplete: () => {
                                item.classList.add('--revealed');
                                gsap.set('.project-card__image', { clearProps: 'all' });
                            },
                        });

                        revealTl.to(overlay, {
                            duration: 1, y: '-100%', ease: 'power3.inOut',
                        }, 0);
                        revealTl.to(image, {
                            duration: 2, scale: 1, ease: 'power2.out',
                        }, 0);
                        revealTl.to(button, {
                            duration: 0.7, autoAlpha: 1, ease: 'power4.inOut',
                        }, 0.6);
                        revealTl.to(content, {
                            duration: 0.7, autoAlpha: 1, ease: 'power4.inOut',
                        }, 0.6);
                    });
                },
            });

            this.revealsAdded = true;
        },

        onLeave(el, done) {
            gsap.to('.project-card', {
                duration: 1,
                autoAlpha: 0,
                ease: 'power4.out',
                onComplete: () => {
                    done();

                    window.scrollTo(0, 0);

                    Vue.nextTick(() => {
                        if (!this.revealsAdded) {
                            this.revealsAdded = true;
                            this.initReveals();
                            EventBus.$emit('refresh-scroll-indicator');
                        }
                    });
                },
            });

            EventBus.$emit('toggle-filter');
        },
    },
});
